import React from 'react'

import { cn } from '@/lib/utils.ts'

export interface CountBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  readonly count: number
}

export const CountBadge = React.forwardRef<HTMLSpanElement, CountBadgeProps>(({ count, className, ...props }, ref) =>
  count > 0 ? (
    <span
      ref={ref}
      className={cn(
        'inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-[3px] bg-red-700 px-1 text-sm leading-none font-normal text-white',
        className
      )}
      {...props}>
      {count}
    </span>
  ) : null
)
